<template>
  <div class="pb-8">
    <slot />
  </div>
</template>
